import React from 'react';
import { Spinner as SpinnerBootstrap, SpinnerProps } from 'react-bootstrap';

interface ISpinnerProps {
    className?: string;
    size?: SpinnerProps['size'] | 'md';
}

export const Spinner = ({ size = 'md', className = '' }: ISpinnerProps) => ( //@ts-ignore
    <SpinnerBootstrap className={className} animation="border" variant="warning" size={size}>
        <span className="visually-hidden">Loading...</span>
    </SpinnerBootstrap>
);